import * as React from 'react';
import { PrimaryButton, PrimaryButtonProps } from '../PrimaryButton';

type Props = Omit<PrimaryButtonProps, 'rightIconId'>;

// new-ui
export function AddPrimaryButton(props: Props) {
  return <PrimaryButton isSmall {...props} rightIconId='add' />;
}
